import {
  METHOD_TYPE_FETCH_REQUEST,
  METHOD_TYPE_FETCH_REQUEST_FAILURE,
  METHOD_TYPE_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */

const channelMethodTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case METHOD_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case METHOD_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case METHOD_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default channelMethodTypesReducer;
